<div
  class="direct-block jumbotron jumbotron-fluid mb-0 py-0"
  [ngStyle]="{
    'background-image': 'url(' + content.url + ')',
    'background-color': content.bgcolor,
  }"
>
  <div>
    <h2
      *ngIf="showTitle && content.title"
      class="display-4"
      [ngStyle]="{ color: content.color }"
    >
      {{ content.title }}
    </h2>
    <div
      *ngIf="content.body || content.color"
      [ngStyle]="{ color: content.color }"
      [innerHtml]="content.body | bypassSecurity"
    ></div>
  </div>
</div>
